import WithGASetup from '../WithGASetup';
import UserNotRecognized from './UserNotRecognized';

export default WithGASetup(UserNotRecognized);
